import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { bidMultiplierUtils } from '../hotel-center-utils';
import InlineEditView from './inline-edit-view';
import template from './multiplier-inline-edit-template.pug';
import {
  HotelModel, SubAccountModel, HotelGroupModel, BidMultipliersView,
} from '../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');

class BidMultipliersInlineEditView extends InlineEditView {
  constructor({ selectedItem, bidMultipliersView, serverContext = { DynamicPermissions: {} } }) {
    super({ view: bidMultipliersView, hasCleanButton: true });
    this.view.on('update:isUseParent', (isUseParent) => {
      this.getChild('edit-panel-view').setState({ isCleanButtonDisabled: isUseParent });
    });
    this.serverContext = serverContext;
    this.updateBidMultipliersView(selectedItem);
    this.inlineEditHotelMultiplierActivity =
    this.overViewPageScenario.inlineEditHotelMultiplier.create();
  }

  updateBidMultipliersView(selectedItem) {
    if (!selectedItem.BidMultipliers) {
      return;
    }

    const bidMultipliers = bidMultiplierUtils.getMultipliersState(selectedItem.BidMultipliers);

    this.view.emptyDeviceTypeAndCheckInDay();
    this.view.setState({
      bidMultipliers,
      isPayPerStay: _.result(selectedItem.Bid, '@odata.type') === '#Model.PayPerStayBid',
      isPayPerStayPhase2Pilot: this.serverContext.DynamicPermissions.ReconciliationReport,
    });
  }

  get template() {
    return template;
  }
}

export class HotelBidMultipliersInlineEditView extends BidMultipliersInlineEditView {
  constructor({ selectedItem, serverContext }) {
    const bidMultipliersView = new BidMultipliersView();

    super({ selectedItem, bidMultipliersView, serverContext });
    this.selectedItem = selectedItem;
    this.scope = i18n.getString('HotelCenter_Overview_Grid_Switcher_Hotel_Id_Label');
  }

  processEditChange(state) {
    const subAccountId = this.selectedItem.SubAccountId;
    const entitySet = subAccountId ?
      edm.currentAccount.SubAccounts.$withKey(subAccountId).Hotels :
      _.noop();
    const hotelModel = new HotelModel({ Id: this.selectedItem.Id, entitySet });

    hotelModel.set('BidMultipliers', state.bidMultipliers);

    const saveModel = hotelModel
      .save(['BidMultipliers'], { patch: true });

    this.inlineEditHotelMultiplierActivity.trace(`Hotel inline edit bid multiplier did save model with ${saveModel}`);
    return saveModel;
  }

  updateBidMultipliersView(selectedItem) {
    super.updateBidMultipliersView(selectedItem);
    const bidMultiplierSource = selectedItem.BidMultiplierSource;

    const isUseParent = bidMultiplierSource === 'HotelGroup' || bidMultiplierSource === 'SubAccount';
    const isPayPerStay = _.result(selectedItem.Bid, '@odata.type') === '#Model.PayPerStayBid';
    const isPayPerStayPhase2Pilot = this.serverContext.DynamicPermissions.ReconciliationReport;
    this.getChild('edit-panel-view').setState({
      isCleanButtonDisabled: isUseParent || isPayPerStay,
      isSaveButtonDisabled: isPayPerStay && !isPayPerStayPhase2Pilot,
    });

    this.view.setState({ isUseParent });
  }
}

export class HotelGroupBidMultipliersInlineEditView extends BidMultipliersInlineEditView {
  constructor({ selectedItem, serverContext }) {
    const bidMultipliersView = new BidMultipliersView();

    super({ selectedItem, bidMultipliersView, serverContext });
    this.selectedItem = selectedItem;
    this.scope = i18n.getString('HotelCenter_Overview_Grid_Switcher_Hotel_Group_Label');
  }

  processEditChange(state) {
    const subAccountId = this.selectedItem.SubAccountId;
    const entitySet = subAccountId ?
      edm.currentAccount.SubAccounts.$withKey(subAccountId).HotelGroups :
      _.noop();
    const hotelGroupModel = new HotelGroupModel({
      Id: this.selectedItem.Id,
      Name: this.selectedItem.Name,
      entitySet,
    });

    hotelGroupModel.set('BidMultipliers', state.bidMultipliers);

    const saveModel = hotelGroupModel
      .save(['BidMultipliers'], { patch: true });
    this.inlineEditHotelMultiplierActivity.trace(`Hotel group inline edit bid multiplier did save model with ${saveModel}`);
    return saveModel;
  }

  updateBidMultipliersView(selectedItem) {
    super.updateBidMultipliersView(selectedItem);
    const bidMultiplierSource = selectedItem.BidMultiplierSource;

    const isUseParent = bidMultiplierSource === 'SubAccount' || _.result(selectedItem, 'Name') === 'Ungrouped';
    const isPayPerStay = _.result(selectedItem.Bid, '@odata.type') === '#Model.PayPerStayBid';
    const isPayPerStayPhase2Pilot = this.serverContext.DynamicPermissions.ReconciliationReport;

    this.getChild('edit-panel-view').setState({
      isCleanButtonDisabled: isUseParent || isPayPerStay,
      isSaveButtonDisabled: isPayPerStay && !isPayPerStayPhase2Pilot,
    });

    this.view.setState({ isUseParent });
  }
}

export class SubAccountBidMultipliersInlineEditView extends BidMultipliersInlineEditView {
  constructor({ selectedItem, currentSubAccountId, serverContext }) {
    const bidMultipliersView = new BidMultipliersView({
      showUseParent: false,
    });

    super({ selectedItem, bidMultipliersView, serverContext });
    this.selectedItem = selectedItem;
    this.scope = i18n.getString('HotelCenter_Overview_Grid_Switcher_Hotel_SubAccount_Label');
    if (currentSubAccountId === selectedItem.Id) {
      this.refreshForSubAccountBar = true;
    }
  }

  processEditChange(state) {
    const subAccountModel = new SubAccountModel({
      Id: this.selectedItem.Id,
      Name: this.selectedItem.Name,
    });

    subAccountModel.set('BidMultipliers', state.bidMultipliers);

    const saveModel = subAccountModel
      .save(['BidMultipliers'], { patch: true });

    this.inlineEditHotelMultiplierActivity.trace(`SubAccount inline edit bid multiplier did save model with ${saveModel}`);
    return saveModel;
  }
}

